import { FC, ReactNode } from 'react';
import { Asset, Box, useThemeValue } from '@altermaind/web/ui';
import { UserInfo } from '@/_shared/components/UserInfo';
import { convertColorToRgba } from '@/_shared/helpers/convertColorToRgba';

type Props = {
  children?: ReactNode;
};

export const WrapperConversation: FC<Props> = ({ children }) => {
  const primary = useThemeValue('colors', 'primary/background') || 'transparent';
  const firstGradient = {
    positionY: 'top',
    positionX: 'center',
    width: '50%',
    height: '250px',
  };
  const secondGradient = {
    positionY: 'bottom',
    positionX: 'left',
    width: '80%',
    height: '400px',
  };
  const primaryBg = convertColorToRgba(primary, 1);
  const radialBg = `radial-gradient(${firstGradient.width} ${firstGradient.height} ellipse at ${firstGradient.positionY} ${firstGradient.positionX},#6b34fc, transparent, transparent), radial-gradient(${secondGradient.width} ${secondGradient.height} ellipse at ${secondGradient.positionY} ${secondGradient.positionX}, #6b34fc, ${primaryBg}, ${primaryBg})`;

  return (
    <Box width='100%' p='xs' minHeight='100vh' style={{ background: radialBg }}>
      <Box
        justifyContent='space-between'
        alignItems='center'
        pt='xxs'
        display='flex'
        flexDirection='row'
        pb='s'
      >
        <Box>
          <Asset domain='images' name='logoAltermaind' width='50' />
        </Box>
        <Box>
          <UserInfo />
        </Box>
      </Box>
      {children}
    </Box>
  );
};
